import modules_list from './list/index.js'
import modules_form from './form/index.js'
import _actions_search from './_actions/search.js'
import _actions_clean from './_actions/clean.js'
import _actions_change from './_actions/change.js'
import _actions_back from './_actions/back.js'
import _mutations_value from './_mutations/value.js'
import _mutations_tab from './_mutations/tab.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        tab: _mutations_tab,
        value: _mutations_value,
    },
    actions:{
        back: _actions_back,
        change: _actions_change,
        clean: _actions_clean,
        search: _actions_search,
    },
    modules:{
        form: modules_form,
        list: modules_list,
    },
}